import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SensorWindowIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sensor_window"}/>
}
